shadow$provide[434] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec4 resampleFactor;

vec4 resampleRelative(vec4 xyzw) {
  return xyzw * resampleFactor;
}`;

};